export default function StatsSection() {
  const stats = [
    {
      value: "1,000万+",
      label: "原创资源总量",
      desc: "海量原创图文素材持续更新",
      icon: "ri-database-2-line",
      color: "primary"
    },
    {
      value: "5,000+",
      label: "认证创作者",
      desc: "与专业创作者深度合作",
      icon: "ri-user-star-line",
      color: "accent"
    },
    {
      value: "200万+",
      label: "服务企业客户",
      desc: "为企业品牌传播赋能",
      icon: "ri-building-4-line",
      color: "secondary"
    },
    {
      value: "99.8%",
      label: "版权合规率",
      desc: "严格把控原创版权品质",
      icon: "ri-shield-check-line",
      color: "primary"
    },
    {
      value: "500件/天",
      label: "日新增资源",
      desc: "每日持续补充优质内容",
      icon: "ri-refresh-line",
      color: "accent"
    },
    {
      value: "24小时",
      label: "版权响应",
      desc: "快速处理版权投诉举报",
      icon: "ri-customer-service-2-line",
      color: "secondary"
    }
  ];

  return (
    <section className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 text-secondary-500 text-sm font-medium mb-3">
            <i className="ri-bar-chart-2-line"></i>
            <span>平台实力</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            数字见证，品质可信
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            千万正版素材库背后，是我们对原创内容资源品质的持续追求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {stats.map((stat, i) => (
            <div
              key={i}
              className="p-6 rounded-2xl bg-background-100 border border-background-200 hover:border-primary-200 transition-all duration-200"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl mb-4 ${
                stat.color === "primary"
                  ? "bg-primary-100 text-primary-500"
                  : stat.color === "accent"
                  ? "bg-accent-100 text-accent-500"
                  : "bg-secondary-100 text-secondary-500"
              }`}>
                <i className={`${stat.icon} text-xl`}></i>
              </div>
              <div className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-1">
                {stat.value}
              </div>
              <div className="font-medium text-foreground-800 text-sm mb-1">{stat.label}</div>
              <div className="text-foreground-500 text-xs">{stat.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}